module.exports = __webpack_public_path__ + "static/img/upload_image.7a304cab.png";